import React from 'react';
import AppListToolbarGlobal, { type CompanyOption } from '@/__core/components/AppLisstToolbarGlobal';




export interface IssuesToolbarGlobalProps {
  /** @deprecated Chỉ dùng khi test; mặc định lấy từ auth + resolveModuleAccessibleCompanies */
  companies?: CompanyOption[];
  fetchCompanies?: () => Promise<CompanyOption[]>;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: () => void;
  onToggleAdvancedSearch?: () => void;
  isAdvancedSearchOpen?: boolean;
  onFilterChange?: (field: string, value: string) => void;

  filters?: {
    company: string;
    status: string;
  };
  statusOptions?: Array<{ id: string; name: string }>;
  onRefresh?: () => void;
}

export default function IssuesToolbarGlobal({
  companies,
  searchQuery = '',
  onSearchChange,
  onSearchSubmit,
  onToggleAdvancedSearch,
  isAdvancedSearchOpen = false,
  filters = { company: 'all', status: 'all' },
  onFilterChange,
  statusOptions = [],
  onRefresh,
}: IssuesToolbarGlobalProps) {
  const statusFilterOptions = React.useMemo(
    () => statusOptions.map((option) => ({ value: option.id, label: option.name })),
    [statusOptions]
  );

  const advancedFilterFields = React.useMemo(
    () => [
      {
        key: 'status',
        label: 'Trạng thái',
        labelWidth: 90,
        value: filters.status,
        placeholder: 'Chọn trạng thái',
        options: statusFilterOptions,
        onChange: (value: string) => onFilterChange?.('status', value),
        gridSize: { xs: 12, sm: 6, md: 6 },
      },
    ],
    [filters.status, onFilterChange, statusFilterOptions]
  );


  return (
    <AppListToolbarGlobal
      scopeModule='issues'
      companies={companies}
      searchPlaceholder='Tìm theo mã phiếu xuất, đơn hàng, kho, ghi chú...'
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      onSearchSubmit={onSearchSubmit}
      isAdvancedSearchOpen={isAdvancedSearchOpen}
      onToggleAdvancedSearch={onToggleAdvancedSearch}
      selectedCompany={filters.company}
      onCompanyChange={(id) => onFilterChange?.('company', id)}
      advancedFilterFields={advancedFilterFields}
    />
  );
}
